export default __webpack_public_path__ + "static/media/homepage.443aee96.png";